import React from 'react';
import CartModalItem from './CartModalItem';
import CartModalEmpty from './CartModalEmpty';

function CartModalBody(props) {
    const {
        items,
        hasItems,
        removeItem,
        currencyFormat,
        currencyDisplayCode,
        locale,
    } = props;

    if (!hasItems) {
        return <CartModalEmpty />;
    }

    return (
        <ul className='cart-list form'>
            {items.map((item) => {
                const { Children = [] } = item;

                return (
                    <React.Fragment key={item.ID}>
                        <CartModalItem
                            key={item.ID}
                            item={item}
                            itemQty = {item.TotalUnitItems}
                            removeItem={removeItem}
                            currencyFormat={currencyFormat}
                            currencyDisplayCode={currencyDisplayCode}
                            locale={locale}
                        />

                        {Children.map((subitem) => (
                            <CartModalItem
                                key={subitem.ID}
                                item={subitem}
                                itemQty = {Children.length > 1 ? item.TotalUnitItems : subitem.TotalUnitItems}
                                removeItem={removeItem}
                                currencyFormat={currencyFormat}
                                currencyDisplayCode={currencyDisplayCode}
                                locale={locale}
                            />
                        ))}
                    </React.Fragment>
                );
            })}
        </ul>
    );
}

export default CartModalBody;
